module.exports = __webpack_public_path__ + "static/media/Press-1.aec38585.png";